var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "villages__item" }, [
    _c(
      "a",
      { attrs: { href: _vm.item.DETAIL_PAGE_URL } },
      [
        _c("slider-photo", {
          staticClass: "slider-villages",
          attrs: { item: _vm.item, "max-height": 188 },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "villages__content-wrapper" }, [
      _c("div", { staticClass: "villages__content" }, [
        _c("a", { attrs: { href: _vm.item.DETAIL_PAGE_URL } }, [
          _c("p", { staticClass: "villages__content-title" }, [
            _c("a", { attrs: { href: _vm.item.DETAIL_PAGE_URL } }, [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.item.NAME) +
                  "\n                "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.item.PROPS && _vm.item.PROPS.ADDRESS && _vm.item.PROPS.ADDRESS[0]
            ? _c("p", { staticClass: "villages__content-teg" }, [
                _c("span", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.item.PROPS.ADDRESS[0].VALUE) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm.item.ADDRESS
            ? _c("p", { staticClass: "villages__content-teg" }, [
                _c("span", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.item.ADDRESS) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm.item.PROPS &&
              _vm.item.PROPS.LOCATION &&
              _vm.item.PROPS.LOCATION[0]
            ? _c("p", { staticClass: "villages__content-teg" }, [
                _c("span", [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.item.PROPS.LOCATION[0].VALUE) +
                      "\n                "
                  ),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.item.PROPS && _vm.item.PROPS.ADDRESS_ADV
            ? _c(
                "ul",
                { staticClass: "villages__content-list" },
                _vm._l(_vm.item.PROPS.ADDRESS_ADV, function (address) {
                  return _c("li", [
                    _c("span", { staticClass: "villages__content-link" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(address.VALUE) +
                          "\n                    "
                      ),
                    ]),
                  ])
                }),
                0
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c("a", { attrs: { href: "#reviewResident" } }, [
        _c("div", { staticClass: "village-rating" }, [
          _c("div", { staticClass: "rating" }, [
            _c("img", {
              staticClass: "rating-img",
              attrs: {
                loading: "lazy",
                src: _vm.getPath("icon-rating.svg"),
                alt: "Icon",
              },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "rating-number" }, [_vm._v("4.9")]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "reviews" }, [
            _c("img", {
              staticClass: "reviews-img",
              attrs: {
                loading: "lazy",
                src: _vm.getPath("icon-reviews.svg"),
                alt: "Icon",
              },
            }),
            _vm._v(" "),
            _vm.item.PROPS &&
            _vm.item.PROPS.COUNT_FEED &&
            _vm.item.PROPS.COUNT_FEED[0]
              ? _c("div", { staticClass: "reviews-count" }, [
                  _vm._v(
                    _vm._s(_vm.item.PROPS.COUNT_FEED[0].VALUE) + " отзывов"
                  ),
                ])
              : _vm._e(),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.item.FREE_COUNT < 1
      ? _c("div", { staticClass: "slider-villages-teg" }, [
          _c("img", {
            attrs: {
              loading: "lazy",
              src: _vm.getPath("icon-check-white.svg"),
              alt: "Icon",
            },
          }),
          _vm._v(" "),
          _c("p", [_vm._v("Полностью реализован")]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }